import { BaseVue, Component } from '@newview/base-web';
import {Button, Event, Setting, LoadDataOptions, GloablValue, ValueRule, GridOption} from "./DataUIType";
import { BaseApi, BaseApiV2 } from '@newview/infrastructure';
import {FilterHelper, getOSSClient} from '@newview/tools';
import searchCom from "../searchCom.vue";
import { QueryWrapper } from "@newview/infrastructure";
import { FileinforApi } from "@newview/system-api";
import ColumnHeaderFilter from "./ColumnHeaderFilter.vue";
let OSS = require("ali-oss");
export class DataGridOptions extends BaseVue {

  fileinforApi: FileinforApi = new FileinforApi();
  loadDataing: boolean = false;
  dataGridSpinShow = false
  gridBoxId = "gridBox_" + this.NewGuid();
  gridEleId = "grid_" + this.NewGuid();
  ossClient: any = {};
  option: any = {
    setting: {},
    columns: []
  };

  api?: BaseApi | BaseApiV2;
  event: Event = {};

  // 基础设置
  toolbars: Button[] = [];
  setting: Setting = {
    rowKey: 'Id',
    operates: "",
    mode: 'edit',
    isPagination: false,
    pageSize: 16,
    isTree: false,
    isHighlightSelectRow: true,
    isShowChildren: true,
    showSummary: false,
    summaryMethod: undefined,
    height: 0,
    maxHeight: undefined,
    startEdit: false,
    filterPopperClass:""
  };

  // 查询
  searchSetting1: any = []
  showSearch: boolean = false;
  searchDisplay: string = 'none';

  // 分页参数
  pageSize: number = 25;
  pageIndex: number = 1;
  total: number = 0;
  // size: number = 0;

  isTree: boolean = false; // 是否为树表
  filter?: string; // 查询
  orderBy?: string; // 排序
  queryWrapper?: QueryWrapper;

  readFunction?: (options: LoadDataOptions) => void;

  hasDefaultEventButton: string[] = ["add", "addchild", "save", "delete", "refresh", "edit"]; // 有默认功能

  /**
   * 原始数据
   */
  datas: any[] = [];

  /**
   * 全部数据
   */
  allDatas: any[] = [];

  /**
   * 编辑后数据
   */
  editDatas: any[] = [];

  /**
   * 全局值
   */
  gloablValues: GloablValue[] = [];

  /**
   * 记录表头全选值
   */
  allCheckValue: boolean = false;

  /**
   * 当前选择的行
   */
  currentRow: any = undefined;

  /**
   * 默认权限Key
   */
  defaultChkAllKey: string = 'AllKey';

  /**
   * 表格高度
   */
  gridBoxHeightNow: string = '';

  /** 设置全局点击事件 */
  gloablClick?: Function;

}

/**
 * 功能开发步骤
 * 1：统一配置项 - 设置默认配置项
 * 2: 通过类对象的模式提供Api
 * 3：定义事件
 * 4：开发基础Api
 * 
 * 需要解决的问题：
 * 1、$ref下智能提示
 * 2、通过定义Html元素渲染
 * 3、封装基础方法
 * 
 */
@Component({
  name: "DataGrid",
  components: { searchCom }
})
export default class DataGrid extends DataGridOptions {

  //#region 默认处理过程

  /**
   * 默认删除事件
   * @param row 
   */
  private async doDefaultDelete(row) {
    let idKey = row.Id ? "Id" : "$rowId";
    let id = row[idKey];
    if (!this.api || id < 0) { // 未绑定Api 或者 id 小于 0
      let element = this.getRowById(id);
      this.datas = this.deletedData(this.datas, element)
      this.editDatas = this.deletedData(this.editDatas, element)
      this.isShowDataGrid = false
      this.$nextTick(() => {
        this.isShowDataGrid = true
      })
      return;
    }

    // 删除前事件 弋
    if (this.event && this.event.event_deleteBefore && !this.event.event_deleteBefore(row.Id, row)) return;

    let msg = '该条数据';
    if (this.setting.delMsgKey && row[this.setting.delMsgKey]) {
      msg = row[this.setting.delMsgKey];
      msg = msg ? msg : ""
    }

    this.confirm("确定要删除" + msg + "吗?", async () => {
      this.ossClient = await getOSSClient();
      this.dataGridSpinShow = true
      const apiResult = await this.api!.delete(row.Id);
      if (apiResult.code == 200) {
        setTimeout(() => {
          this.dataGridSpinShow = false
        }, 500);
        this.$Message.info("删除成功!");
        if (!this.isNull(row.Token)) {
          //获取到行数据Token
          let result: any = await this.fileinforApi.getEntityByToken(row.Token)
          if (result.code == 200 && result.data.length > 0) {
            let fileNames = result.data.map(e => e.fileName);
            await this.ossClient.deleteMulti(fileNames, {
              quiet: true
            });
          }
        }
        this.refresh();
      } else {
        setTimeout(() => {
          this.dataGridSpinShow = false
        }, 500);
        this.$Message.info(`删除失败,${apiResult.msg}.`);
      }

      // 删除后事件
      if (this.event && this.event.event_deleteAfter) this.event.event_deleteAfter(row.Id, apiResult, row);

    })

  }

  intoGloablValue(row) {
    const isAdd = row.$rowId ? true : false;

    for (const gloablValue of this.gloablValues) {
      if (!isAdd && gloablValue.isOnlyAddSetValue == true) continue;

      let value = gloablValue.value;
      switch (value) {
        case ValueRule.datetime:
          value = this.ForMatDate(new Date(), "yyyy-MM-dd hh:mm:ss");
          break;
        case ValueRule.date:
          value = this.ForMatDate(new Date(), "yyyy-MM-dd");
          break;
        case ValueRule.time:
          value = this.ForMatDate(new Date(), "hh:mm:ss");
          break;
        case ValueRule.guid:
          value = this.NewGuid();
          break;
      }
      row[gloablValue.key] = value;
    }

  }

  doToolbarClick(toolbar, row: any, text: any) {
    if (this.gloablClick) {
      if (this.gloablClick(toolbar, row, text) == true) {
        if (toolbar.onclick) {
          toolbar.onclick(row, text);
        }
      }
    } else {
      if (toolbar.onclick) {
        toolbar.onclick(row, text);
      }
    }

    // if (this.gloablClick) {
    //   this.gloablClick(btn, params.row, text);
    // }
    // else if (btn.onclick) btn.onclick(params.row, text);
  }

  /**
   * 默认保存事件
   */
  private async doDefaultSave() {
    if (!this.api) {
      this.error('未绑定Api');
      return;
    }

    const saveDatas: any[] = JSON.parse(JSON.stringify(this.editDatas));

    if (saveDatas.length == 0) {
      this.warning("您还未添加或修改任何数据！")
      return
    }

    for (const item of saveDatas) {
      this.intoGloablValue(item);
      if (item.Id <= 0) {
        item.Id = 0
      }
    }

    // 保存前事件
    if (this.event && this.event.event_saveBefore && !this.event.event_saveBefore(saveDatas)) return;

    this.dataGridSpinShow = true
    const apiResult = this.isTree ? await this.api.saveTree(saveDatas) : await this.api.saves(saveDatas);
    const result = this.parseApiResult(apiResult);
    if (result > 0) {
      setTimeout(() => {
        this.dataGridSpinShow = false
      }, 500);
      this.$Message.info("保存成功");
      this.refresh();
    } else {
      setTimeout(() => {
        this.dataGridSpinShow = false
      }, 500);
      this.$Message.info("保存失败");
    }

    // 保存后事件
    if (this.event && this.event.event_saveAfter) this.event.event_saveAfter(saveDatas, result);

  }

  /**
   * 默认刷新事件
   */
  private doDefaultRefresh() {
    this.refresh();
  }

  /**
   * 默认编辑事件
   */
  private doDefaultEdit(row, text) {

    const isEdit = text != '取消';
    this.setRowEdit(row, isEdit);

  }

  /**
   * 默认添加事件
   */
  doDefaultAdd(isAddChild: boolean = false, data: any = {}) {
    let row: any = Object.assign({
      $isEdit: true,
      $rowId: this.NewGuid(),
      $isChange: true,
      $isAdd: true,
      Id: -1 * (Date.now() - parseInt((Date.now() + "").substring(0, 4) + "000000000")),
      SKey: this.NewGuid()
    }, this.getDefaultValues());
    row = Object.assign(row, data);
    if (this.isTree) {

      row.FakeId = this.NewGuid();
      row.FakePId = null;
      row.children = [];

      if (this.currentRow && isAddChild == true) {

        row.RootId = this.currentRow.RootId;
        row.NodeLevel = this.currentRow.NodeLevel + 1;

        if (this.currentRow.Id > 0) {

          row.PId = this.currentRow.Id;
          row.RootId = this.currentRow.RootId;
          row.NodeLevel = this.currentRow.NodeLevel + 1;
          row.ParentPath = this.currentRow.ParentPath + row.PId + "/";

        } else {

          row.PId = 0;
          row.FakePId = this.currentRow.FakeId;
        }

      } else {

        row.PId = 0;
        row.RootId = 0;
        row.NodeLevel = 1;
        row.ParentPath = '/';

      }
    }

    this.addRow(row, isAddChild);

  }

  /**
   * 添加行数据
   * @param data 
   */
  addRowData(data) {
    this.doDefaultAdd(false, data);
  }

  doDefaultAddChild(selectedRow: any) {
    if (!this.isNull(selectedRow)) {
      this.currentRow = selectedRow;
    }
    let row: any = Object.assign({
      $isEdit: true,
      $rowId: this.NewGuid(),
      $isChange: true,
      $isAdd: true,
      Id: -1 * (Date.now() - parseInt((Date.now() + "").substring(0, 4) + "000000000")),
      SKey: this.NewGuid()
    }, this.getDefaultValues());

    if (this.isTree) {

      row.FakeId = this.NewGuid();
      row.FakePId = null;
      row.children = [];

      if (selectedRow) {

        row.RootId = selectedRow.RootId;
        row.NodeLevel = selectedRow.NodeLevel + 1;

        if (selectedRow.Id > 0) {

          row.PId = selectedRow.Id;
          row.RootId = selectedRow.RootId;
          row.NodeLevel = selectedRow.NodeLevel + 1;
          row.ParentPath = selectedRow.ParentPath + row.PId + "/";

        } else {

          row.PId = 0;
          row.FakePId = this.currentRow.FakeId;
        }

      } else {

        row.PId = 0;
        row.RootId = 0;
        row.NodeLevel = 1;
        row.ParentPath = '/';

      }
    }

    this.addRow(row, true);
  }

  private doCheckedAll(key, value) {
    for (const data of this.datas) {
      this.$set(data, key, value);
    }
  }

  private doCheckedRows(row, key, value) {
    let id = row.Id ? "Id" : "$rowId";

    let element = this.getRowById(row[id]);
    this.$set(element, key, value);
  }

  //#endregion 默认处理过程

  //#region 工具方法

  /**
   * 添加Edit数据
   * @param row 
   */
  private addEditData(row: any) {
    let id = row.Id ? "Id" : "$rowId";
    var models = this.editDatas.filter(item => item[id] == row[id]);

    if (models.length == 0) {
      this.editDatas.push(row);
    }

  }

  /**
   * 解析按钮    
   * @param toolbars 
   */
  private parseButtons(toolbars: any = []) {
    let menuInfoString: any = sessionStorage.getItem("menu")
    let menuInfo = JSON.parse(menuInfoString)
    let newtoolbars = toolbars
    let newtoolbars1 = JSON.parse(JSON.stringify(toolbars))
    if (menuInfo) {
      let operates = ""
      if (menuInfo.operates) {
        operates = menuInfo.operates
      }
      for (const element of newtoolbars1) {
        if (element.name == 'add' && operates.indexOf('Add') == -1) {
          newtoolbars.splice(newtoolbars1.indexOf(element), 1);
        }
        if (element.name == 'save' && operates.indexOf('Save') == -1) {
          newtoolbars.splice(newtoolbars1.indexOf(element), 1);
        }
        if (element.name == 'edit' && operates.indexOf('Edit') == -1) {
          newtoolbars.splice(newtoolbars1.indexOf(element), 1);
        }
        if (element.name == 'delete' && operates.indexOf('Clear') == -1) {
          newtoolbars.splice(newtoolbars1.indexOf(element), 1);
        }
      }
    }

    for (let toolbar of newtoolbars) {

      if (this.hasDefaultEventButton.indexOf(toolbar.name) == -1) {
        continue;
      }

      const name = toolbar.name.toLowerCase();

      switch (name) {
        case "save":
          toolbar.text = !this.isNull(toolbar.text) ? toolbar.text : "保存";
          toolbar.iconClass = !this.isNull(toolbar.iconClass) ? toolbar.iconClass : "iconfont iconsave";
          toolbar.onclick = !this.isNull(toolbar.onclick) ? toolbar.onclick : this.Tools.debounce(this.doDefaultSave);
          break;
        case "delete":
          toolbar.text = !this.isNull(toolbar.text) ? toolbar.text : "删除";
          toolbar.iconClass = !this.isNull(toolbar.iconClass) ? toolbar.iconClass : "md-trash";
          toolbar.onclick = !this.isNull(toolbar.onclick) ? toolbar.onclick : this.doDefaultDelete;
          break;
        case "refresh":
          toolbar.text = !this.isNull(toolbar.text) ? toolbar.text : "刷新";
          toolbar.iconClass = !this.isNull(toolbar.iconClass) ? toolbar.iconClass : "md-refresh";
          toolbar.type = "success";
          toolbar.onclick = !this.isNull(toolbar.onclick) ? toolbar.onclick : this.Tools.debounce(this.doDefaultRefresh);
          break;
        case "add":
          toolbar.text = !this.isNull(toolbar.text) ? toolbar.text : "添加";
          toolbar.iconClass = !this.isNull(toolbar.iconClass) ? toolbar.iconClass : "md-add";
          toolbar.onclick = !this.isNull(toolbar.onclick) ? toolbar.onclick : this.doDefaultAdd;
          break;
        case "addchild":
          toolbar.text = !this.isNull(toolbar.text) ? toolbar.text : "新增子项";
          toolbar.iconClass = !this.isNull(toolbar.iconClass) ? toolbar.iconClass : "md-add";
          toolbar.onclick = !this.isNull(toolbar.onclick) ? toolbar.onclick : this.doDefaultAddChild;
          break;
        case "edit":
          toolbar.text = !this.isNull(toolbar.text) ? toolbar.text : "编辑";
          toolbar.iconClass = !this.isNull(toolbar.iconClass) ? toolbar.iconClass : "md-create";
          toolbar.onclick = !this.isNull(toolbar.onclick) ? toolbar.onclick : this.doDefaultEdit;
          break;
      }
    }

  }

  /**
   * 创建行按钮
   * @param h 
   * @param params 
   * @param btn 
   */
  private createRowButton(h: any, params, btn: Button, isEnable: boolean) {

    let text = btn.name.toLowerCase() == 'edit' && params.row.$isEdit ? "取消" : btn.text;
    const style: any = !isEnable ? {
      color: "#c5c8ce !important",
      backgroundColor: "transparent"
    } : {}
    return h(
      "Button",
      {
        props: {
          type: "text",
          size: "small",
          // icon: btn.iconClass,
          disabled: !isEnable
        },
        style: Object.assign({ padding: '0 8px' }, style),
        class: `grid-row-btn theme-color ${btn.className}`,
        on: {
          click: () => {
            this.doToolbarClick(btn, params.row, text);
            // if (this.gloablClick) {
            //   this.gloablClick(btn, params.row, text);
            // }
            // else if (btn.onclick) btn.onclick(params.row, text);
          }
        }
      }, text);
  }

  private getDataRowById(datas: any[], id) {
    for (const element of datas) {
      if (element['Id'] == id || element['$rowId'] == id) {
        return element;
      }

      if (element.children && element.children.length > 0) {
        var value = this.getDataRowById(element.children, id);
        if (value != undefined) return value;
      }
    }

    return undefined;
  }

  private deletedData(datas: any[], element1: any) {
    let datasss = datas
    for (const element of datas) {
      if (datas.indexOf(element1) != -1) {
        datasss.splice(datasss.indexOf(element1), 1);
        return datasss
      }
      if (element.children && element.children.length > 0) {
        element.children = this.deletedData(element.children, element1);
      }
    }
    return datas
  }
  /**
   * 设置数据值，同时修改datas和editdatas
   * @param row 
   * @param key 
   * @param value 
   */
  public setDataValue(row, key, value) {
    let id = row.Id ? "Id" : "$rowId";

    let element = this.getRowById(row[id]);
    this.$set(element, key, value);
    this.$set(element, "$isChange", true);

    this.addEditData(element);
    return element;
  }

  /**
   * 设置行是否编辑
   * @param row 
   * @param isEdit 
   */
  setRowEdit(row, isEdit) {
    let id = row.Id ? "Id" : "$rowId";
    let element = this.getRowById(row[id]);
    this.$set(element, "$isEdit", isEdit);
    this.$set(row, '$isEdit', isEdit);
  }

  /**
     * 获取数据加载参数
     */
  private getLoadDataOptions(): LoadDataOptions {
    return {
      isPagination: this.getIsPagination(),
      page: this.pageIndex,
      pageSize: this.pageSize,
      filter: this.filter,
      sort: this.orderBy,
      queryWrapper: this.queryWrapper,
      success: this.setDatas,
    }
  }

  /**
   * 设置Table数据
   * @param datas 
   */
  setDatas(data: any) {
    let _datas: any[] = [];
    if (this.getIsPagination()) {
      _datas = data.Datas;
      this.total = data.TotalItemCount;
    } else {
      _datas = data;
    }
    if (this.isTree) { // 树表           
      _datas = this.getTreeListData(_datas, this.setting.isShowChildren, 0, undefined, this.allDatas);
    } else {
      this.allDatas = _datas;
    }

    _datas = _datas?_datas:[]
    this.datas = _datas;
    this.calcRowNumber(this.datas);
    this.editDatas = [];
    this.currentRow = undefined;

    this.resize();
  }

  private calcRowNumber(datas: any[], startIndex: number = 0) {
    if (!this.isNull(datas) && Array.isArray(datas)) {
      let endRow = startIndex;
      for (const row of datas) {
        this.$set(row, '$rowNumber', endRow + 1);
        if (this.setting.startEdit) {
          this.$set(row, '$isEdit', true);
        }
        endRow = row.$rowNumber;

        if (row.children) {
          endRow = this.calcRowNumber(row.children, endRow);
        }
      }
      return endRow;
    }
    return startIndex;
  }

  /**
   * 获取在Column上配置的默认值
   */
  private getDefaultValues() {

    let defaultValue: any = {};

    if (!this.option.columns) {
      return defaultValue;
    }

    for (const column of this.option.columns) {
      if (!this.isNull(column.defaultValue)) {
        defaultValue[column.key!] = column.defaultValue;
      }
    }

    return defaultValue;

  }

  //#endregion Private 方法

  //#region 解析参数

  private renderOrderNumber(column: any) {
    column.title = '序号';
    column.width = column.tree ? 80 : 50;
    column.align = 'center';
    column.key = '$rowNumber';
  }

  private renderRowButton(column: any) {

    this.parseButtons(column.rowButtons!);
    if (!column.align) column.align = 'center';
    if (!column.slot) column.slot = 'action';
    if (!column.fixed) column.fixed = 'right';
    if (!column.width) column.width = 150;

    column.render = (h, params) => {
      let rowBtns: any[] = [];
      for (const rowBtn of column.rowButtons!) {
        if (rowBtn.isShow && !rowBtn.isShow(params.row)) {
          continue;
        }
        let isEnable = true;
        if (rowBtn.isEnable) {
          isEnable = rowBtn.isEnable(params.row);
        }
        rowBtns.push(this.createRowButton(h, params, rowBtn, isEnable));
      }
      return h("div", rowBtns);
    }

  }

  private renderEditCheckbox(column: any) {

    column.align = 'center';
    column.width = column.width > 50 ? column.width : 50;

    if (column.isChkAll) {
      column.renderHeader = (h, params) => {
        return h('div', { style: "width:100%;text-align:center;" }, [
          h(
            "Checkbox",
            {
              props: {
                value: this.allCheckValue
              },
              on: {
                input: (event) => {
                  this.doCheckedAll(column.key ? column.key : this.defaultChkAllKey, event);
                  this.onSelectAll(event)
                },

              },
            },
            // item.title
          )
        ])
      }
    }
    column.renderViewMode = (h, params) => {
      const key = column.key ? column.key : this.defaultChkAllKey;

      return h(
        "Checkbox",
        {
          props: {
            value: params.row[key] > 0
          },
          on: {
            input: (event) => {
              if (!column.chEdit) {
                this.doCheckedRows(params.row, column.key, event);
              } else {
                params.row[column.key!] = event;
                this.setDataValue(params.row, column.key, event);
              }

              if (column.change) {
                let id = params.row.Id ? "Id" : "$rowId";
                column.change(this.getRowById(params.row[id]));
              }
              this.onSelect(event, params.row)
            }
          }
        },
        ""
      );
    }

  }

  private renderEditInput(column: any) {

    let oldValue = '';
    column.renderEditMode = (h, params) => {
      return h("Input", {
        props: {
          value: params.row[column.key!]
        },
        on: {
          input: (value) => {
            oldValue = params.row[column.key!];
            params.row[column.key!] = value;
            this.setDataValue(params.row, column.key, value);
          },
          'on-blur': () => {
            let id = params.row.Id ? "Id" : "$rowId";
            let useChangeValue = true;

            const rowData = this.getRowById(params.row[id]);
            if (column.change) {
              useChangeValue = column.change(rowData);
            }

            if (useChangeValue == false) {
              this.setDataValue(params.row, column.key, rowData[column.key]);
            }
          }
        }
      });
    };

    this.renderViewMode(column);

  }

  private renderEditAutoComplete(column: any) {
    column.renderEditMode = (h, params) => {
      return h("AutoComplete", {
        props: {
          value: params.row[column.key!],
          data: column.autoCompleteProp!.data,
          filterMethod: (value, option) => {
            if (column.autoCompleteProp && column.autoCompleteProp.filterMethod) return column.autoCompleteProp.filterMethod(value, option);
            return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
          }
        },
        on: {
          input: (value) => {
            params.row[column.key!] = value;
            this.setDataValue(params.row, column.key, value);
          },
          'on-blur': () => {
            let id = params.row.Id ? "Id" : "$rowId";
            if (column.change) {
              column.change(this.getRowById(params.row[id]));
            }
          }
        }
      });
    };

    this.renderViewMode(column);
  }

  private renderEditInputNumber(column: any) {
    column.align = 'right';
    column.renderEditMode = (h, params) => {
      return h("InputNumber", {
        props: {
          value: params.row[column.key!],
          min: column.inputNumberProp && column.inputNumberProp.min !== undefined ? column.inputNumberProp.min : -Infinity
        },
        style: {
          width: "100%"
        },
        on: {
          input: (event) => {
            params.row[column.key!] = event;
            const element = this.setDataValue(params.row, column.key, event);
            if (column.change) {
              column.change(element);
            }
          },
          'on-blur': () => {
            let id = params.row.Id ? "Id" : "$rowId";
            if (column.change) {
              column.change(this.getRowById(params.row[id]));
            }
          }
        }
      });
    };

    this.renderViewMode(column);

  }

  private renderEditMonth(column: any) {

    column.renderEditMode = (h, params) => {
      const format = !column.datePicker ? "yyyy-MM" : (column.datePicker.format ? column.datePicker.format : "yyyy-MM");
      const type = !column.datePicker ? "month" : (column.datePicker.type ? column.datePicker.type : "month");
      return h("DatePicker", {
        props: {
          value: params.row[column.key!],
          type: type,
          transfer: true
        },
        on: {
          input: (event) => {
            params.row[column.key!] = event == "" ? event : this.ForMatDate(
              event,
              format
            );
            let element = this.setDataValue(params.row, column.key, params.row[column.key!]);
            column.change(element);
          }
        }
      });
    };
    this.renderViewMode(column);
  }

  private renderEditDatePicker(column: any) {

    column.renderEditMode = (h, params) => {
      const format = !column.datePicker ? "yyyy-MM-dd" : (column.datePicker.format ? column.datePicker.format : "yyyy-MM-dd");
      const type = !column.datePicker ? "date" : (column.datePicker.type ? column.datePicker.type : "date");
      return h("DatePicker", {
        props: {
          value: params.row[column.key!],
          type: type,
          transfer: true
        },
        on: {
          input: (event) => {
            params.row[column.key!] = event == "" ? event : this.ForMatDate(
              event,
              format
            );
            let element = this.setDataValue(params.row, column.key, params.row[column.key!]);
            if (column.change) {
              column.change(element);
            }
          }
        }
      });
    };

    this.renderViewMode(column);

  }

  private renderEditDateTime(column: any) {
    column.renderEditMode = (h, params) => {
      return h("TimePicker", {
        props: {
          value: params.row[column.key!],
        },
        on: {
          input: (event) => {
            params.row[column.key!] = event == "" ? event : event
            let element = this.setDataValue(params.row, column.key, params.row[column.key!]);
            if (column.change) {
              column.change(element);
            }
          }
        }
      });
    };

    this.renderViewMode(column);
  }

  private renderEditSelect(column: any) {
    column.renderEditMode = (h, params) => {
      const sels: any[] = [];
      if (column.selectProp) {
        if (column.selectProp.getData) {
          column.selectProp.data = column.selectProp.getData(params);
        }
        column.selectProp.data!.forEach(function (selItem, index) {
          sels.push(
            h(
              "Option",
              {
                props: {
                  value: selItem.value,
                  transfer: true
                }
              },
              selItem.text
            )
          );
        });
        if (column.selectProp.allowCreate && column.selectProp.filterable) {
          let aa = params.row[column.key!]  // 可编辑的时候回显用
          if (aa) {
            sels.push(
              h(
                "Option",
                {
                  props: {
                    value: aa,
                    transfer: true
                  }
                },
                column.selectProp.data.filter(x => x.value == aa).length > 0 ? column.selectProp.data.filter(x => x.value == aa)[0].text : aa
              )
            )
          }
        }
      }

      return h("Select", {
        props: {
          filterable: column.selectProp ? (column.selectProp.filterable ? column.selectProp.filterable : false) : false,
          allowCreate: column.selectProp ? (column.selectProp.allowCreate ? column.selectProp.allowCreate : false) : false,
          multiple: column.selectProp ? (column.selectProp.multiple ? column.selectProp.multiple : false) : false,
          value: params.row[column.key!],
          transfer: true,
        },
        on: {
          input: (event) => {
            params.row[column.key!] = event;
            let element = this.setDataValue(params.row, column.key, event);
            if (column.change) {
              column.change(element, getValues(event));
            }
          },
          'on-create': val => {
            let a = val
            column.selectProp.data.push({
              value: val,
              text: val,
            })
            params.row[column.key!] = val;
            let element = this.setDataValue(params.row, column.key, val);
            if (column.change) {
              column.change(element, getValues(val));
            }
          }
        }
      }, sels);
    };

    const getValues = (keyValues) => {
      var values: any[] = [];

      if (keyValues instanceof Array) {
        for (var keyValue of keyValues) {
          values.push(FilterHelper.sysDicFilter(
            keyValue,
            column.selectProp!.data
          ))
        }
      } else {
        values.push(FilterHelper.sysDicFilter(
          keyValues,
          column.selectProp!.data
        ))
      }

      return values;
    }

    column.renderViewMode = (h, params) => {

      const keyValues = params.row[column.key!];
      var values: any[] = getValues(keyValues);

      let value: any = values.join(',');

      if (column.format) {
        value = column.format(h, params);
      }

      return h("span", value instanceof Object ? [value] : value);
    };

  }

  private renderViewMode(column: any) {

    column.renderViewMode = (h, params) => {
      let value = column.format ? column.format(h, params) : params.row[column.key!];
      // return h("div",{
      //   class:"nv-text-nowrap",
      //   props:{
      //     title:value,
      //   }
      // }
      if (column.format) {
        if (column.isWrap) {
          return h("div", {
            class: "",
            props: {
              title: value,
            }
          }, value instanceof Object ? [value] : value)
        } else {
          return h("div", {
            class: "nv-text-nowrap",
            props: {
              title: value,
            }
          }, value instanceof Object ? [value] : value)
        }
      }
      return h('div', [
        // 显示的位置上方
        h('Tooltip', {
          props: { placement: 'top', transfer: true }
        }, [
          h('div', {
            class: "nv-text-nowrap",
            style: {
            },
          }, value),
          // 显示的内容
          h('div', {
            slot: 'content',
            style: { whiteSpace: 'normal', wordBreak: 'break-all', maxHeight: '300px', overflowY: 'auto', }
          }, value)
        ])
      ]
        , value instanceof Object ? [value] : value);
    }

  }
  // 手机号码
  private rendermobileNo(column: any) {
    column.renderViewMode = (h, params) => {
      let value = params.row[column.key!];
      var reg = /(\d{3})\d{4}(\d{4})/;
      return h("span", {}, this.commonReg.mobileNo(value) ? value.replace(reg, "$1****$2") : "****")
    }
  }

  // 身份证
  private renderIdCardNo(column: any) {
    column.renderViewMode = (h, params) => {
      let value = params.row[column.key!];
      return h("span", {}, this.commonReg.idCardNo(value) ? value.replace(/(.{6}).*(.{4})/, "$1********$2") : "****")
    }
  }

  // 金额
  private renderMoney(column: any) {
    column.align = 'right';
    column.renderEditMode = (h, params) => {
      return h("div", {
        class: "nv-flex"
      }, [
        h("span", {}, ""),
        h("InputNumber", {
          class: "nv-flex-1",
          props: {
            value: params.row[column.key!] ? params.row[column.key!] : 0,
            min: column.inputNumberProp && column.inputNumberProp.min !== undefined ? column.inputNumberProp.min : -Infinity
          },
          on: {
            input: (value) => {
              params.row[column.key!] = value;
              this.setDataValue(params.row, column.key, value);
            },
            'on-blur': () => {
              let id = params.row.Id ? "Id" : "$rowId";
              let useChangeValue = true;
              const rowData = this.getRowById(params.row[id]);
              if (column.change) {
                useChangeValue = column.change(rowData);
              }
              if (useChangeValue == false) {
                this.setDataValue(params.row, column.key, rowData[column.key]);
              }
            }
          }
        })
      ])
    };
    column.renderViewMode = (h, params) => {
      let value = params.row[column.key!];
      return h("span", {}, this.NumberTofinanceMode(!this.isNull(value) ? value : 0))
    }
  }



  /**
   * 解析列参数
   */
  private parseColumns() {

    if (!this.option.columns) return;
    const parseColumn = (column: any) => {
      if (column.filter) {
        column.renderHeader = (h, params) => {
          let key = this.NewGuid()
          return h('div', { style: "width:100%;text-align:"+column.align?column.align:'center'+";" }, [
            h(
              "span",
              {
                style: { 'margin-right': '5px' }
              },
              column.title
            ),
            h(
              ColumnHeaderFilter,
              {
                props: {
                  type: column.filter.type,
                  options: column.filter.options,
                  multiple: column.filter.multiple,
                  value: column.filter.value,
                  filterPopperClass:this.setting.filterPopperClass
                },
                on: {
                  change: (value) => {
                    column.filter.value = value

                    let filterData = {}
                    this.option.columns.filter(e => e["filter"]).map(e => {
                      filterData[e.key] = e.filter

                    })
                    this.onFilterChange(filterData)
                  }
                },
                slot: "content"
              },

            )
          ])
        }
      }
      switch (column.colType) {
        case "ch":
          this.renderEditCheckbox(column);
          break;
        case "ed":
          this.renderEditInput(column);
          break;
        case "auto":
          this.renderEditAutoComplete(column);
          break;
        case "num":
          this.renderEditInputNumber(column);
          break;
        case "select":
          this.renderEditSelect(column);
          break;
        case "date":
          this.renderEditDatePicker(column);
          break;
        case "datetime":
          this.renderEditDateTime(column);
          break;
        case "month":
          this.renderEditMonth(column);
          break;
        case "mobileNo": //手机号
          this.rendermobileNo(column);
          break;
        case "idcardNo": //身份证号
          this.renderIdCardNo(column);
          break;
        case "money": //金额 
          this.renderMoney(column)
          break;
        default:
          this.renderViewMode(column);
          break;
      }

      column.render = (h, params) => {

        if (params.row.$isEdit && column.renderEditMode && this.getCanEdit(column, params.row)) {
          return column.renderEditMode(h, params);
        } else {
          if (!column.renderViewMode) {
            this.renderViewMode(column);
          }
          return column.renderViewMode!(h, params);
        }

      }
    }

    for (const column of this.option.columns) {

      if (column.isShowOrderNumber) { // 序号
        this.renderOrderNumber(column);
        continue;
      }

      if (column.rowButtons && column.rowButtons.length > 0) { // 设置行按钮
        this.renderRowButton(column);
        continue;
      }

      if (!this.isNull(column.children) && column.children.length > 0) {
        for (const childColumn of column.children) {
          parseColumn(childColumn);
        }
      }

      parseColumn(column);
    }


  }

  /**
   * 是否能编辑
   * @param column 
   * @param row 
   * @returns 
   */
  private getCanEdit(column, row) {
    if (!column.isCanEdit) {
      return true;
    }

    return column.isCanEdit(row);
  }

  /**
   * 解析参数
   * @param option 
   */
  private parseOption(option: any) {

    if (option.api) this.api = option.api;
    if (option.event) this.event = option.event;

    if (option.toolbars) {
      this.toolbars = option.toolbars;
      this.parseButtons(this.toolbars);
    }

    if (option.setting) { // 解析setting
      this.setting = Object.assign(this.setting, option.setting);
      if (this.setting.isTree) {
        this.isTree = this.setting.isTree;
      }
      if (this.setting.pageSize) this.pageSize = this.setting.pageSize;
      if (this.setting.searchSetting && this.setting.searchSetting.length > 0) {
        this.showSearch = true;
        this.searchSetting1 = this.setting.searchSetting;
      }
    }

    this.parseColumns(); // 解析列参数

  }

  //#endregion 解析参数

  //#region Api

  isShowToolbar(toolbar: Button) {
    var isShow = true;
    if (toolbar.isShow) {
      if (typeof (toolbar.isShow) == "boolean") {
        isShow = toolbar.isShow;
      } else {
        isShow = toolbar.isShow();
      }
    }
    return this.btnIsShow(toolbar.name, this.setting.operates) && isShow;
  }

  /**
   * 设置全局值
   * @param key key 
   * @param value  "$datetime" | "$time" | "$guid" | any
   * @param isOnlyAddSetValue 是否只在添加时赋值
   */
  setGloablValue(key, value: "$datetime" | "$time" | "$guid" | any, isOnlyAddSetValue: boolean = false) {
    const values = this.gloablValues.filter(item => item.key == key);

    if (values.length == 0) {
      this.gloablValues.push({ key: key, value: value, isOnlyAddSetValue: isOnlyAddSetValue });
    } else {
      values[0].value = value;
      values[0].isOnlyAddSetValue = isOnlyAddSetValue;
    }
  }

  /**
   * 设置当前查询页
   * @param pageIndex 
   */
  setPageIndex(pageIndex: number) {
    this.pageIndex = pageIndex;
  }

  /**
   * 重置Grid
   */
  reset() {

    this.loadDataing = false;

    this.option = {
      setting: {},
      columns: []
    };

    this.setting = {
      rowKey: 'Id',
      operates: '',
      mode: 'edit',
      isPagination: false,
      pageSize: 25,
      isTree: false,
      isHighlightSelectRow: true,
      isShowChildren: true,
      showSummary: false,
      summaryMethod: undefined,
      height: 0,
      maxHeight: undefined
    };

    this.toolbars = [];

    this.pageSize = 25;
    this.pageIndex = 1;
    this.total = 0;

    this.api = undefined;
    this.event = {};

    this.filter = undefined;
    this.orderBy = undefined;
    this.isTree = false;

    this.readFunction = undefined;

    this.datas = [];
    /**
     * 编辑后数据
     */
    this.editDatas = [];

    /**
     * 全局值
     */
    this.gloablValues = [];

    /**
     * 记录表头全选值
     */
    this.allCheckValue = false;

    /**
     * 当前选择的行
     */
    this.currentRow = undefined;

  }

  /**
   * 设置参数
   * @param option 
   * @param isReset 
   */
  setOption(option: any, isReset: boolean = false) {

    if (isReset) {
      this.reset();
    }

    this.option = Object.assign(this.option, option);
    this.parseOption(this.option);
    this.setGridBoxHeightNow();

  }

  /**
   * 设置Cloumn
   * @param columns
   * @param isReset
   */
  setCloumn(columns: any, isReset: boolean = false) {
    if (isReset) {
      this.reset();
    }
    this.option.columns = columns
    this.parseColumns();
    this.setGridBoxHeightNow();

  }
  /**
   * 更新列属性
   * @param key 
   * @param column 
   */
  updateColumn(key: string, column: any) {
    let orgColumns = this.option.columns!.filter(item => item.key == key);
    if (orgColumns.length > 0) {
      orgColumns[0] = Object.assign(orgColumns[0], column);
    }
  }

  /**
   * 加载数据
   * @param filter 查询参数
   * @param orderBy 排序字段
   * @param select 查询字段
   */
  loadDataByFilter(filter: string = " 1 = 1 ", orderBy: string = " Id ", select: string = "*") {

    if (!this.api) {
      this.error('未绑定Api');
      return;
    }

    this.filter = filter;
    this.orderBy = orderBy;

    this.loadData(async (options: LoadDataOptions) => {

      const apiResult = options.isPagination ?
        await (this.api as BaseApi)!.getEntitiesPageDynamic(options.page!, options.pageSize!, select, options.filter, options.sort) :
        await (this.api as BaseApi)!.getEntitiesDynamic(select, options.filter, options.sort);
      const result = this.parseApiResult(apiResult);

      options.success(result);

    });
  }

  /**
   * 加载数据
   * @param queryWrapper 
   * @returns 
   */
  loadDataByQuery(queryWrapper: QueryWrapper) {
    if (!this.api) {
      this.error('未绑定Api');
      return;
    }

    this.queryWrapper = queryWrapper;

    this.loadData(async (options: LoadDataOptions) => {

      const apiResult = options.isPagination ?
        await (this.api as BaseApiV2)!.getEntitiesPageDynamic(options.page!, options.pageSize!, this.queryWrapper!) :
        await (this.api as BaseApiV2)!.getEntitiesDynamic(this.queryWrapper!);
      const result = this.parseApiResult(apiResult);
      options.success(result);

    });
  }

  /**
   * 加载数据
   * @param readFunction 数据读取方法
   */
  async loadData(readFunction: (options: LoadDataOptions) => void) {
    this.dataGridSpinShow = true
    this.readFunction = readFunction;
    this.loadDataing = true;
    readFunction(this.getLoadDataOptions());
    this.loadDataing = false;
    setTimeout(() => {
      this.dataGridSpinShow = false
    }, 500);
  }

  /**
   * 刷新
   */
  refresh() {
    this.dataGridSpinShow = true
    this.resetSearch();
    if (this.event.event_search) {
      this.event.event_search(this.ref('searchCom1').getparams());
    } else {
      if (this.readFunction) this.readFunction(this.getLoadDataOptions());
    }
    setTimeout(() => {
      this.dataGridSpinShow = false
    }, 500);
  }

  /**
   * 得到查询条件
   */
  getParams() {
    return this.ref('searchCom1').getparams();
  }

  /**
   * 重置查询参数
   */
  resetSearch() {
    this.ref("searchCom1").resetValue();
  }

  /**
   * 递归添加子级节点
   * @param datas 
   * @param row 
   */

  //解决tree数据二级节点，无法展示问题
  isShowDataGrid = true
  private unshiftTreeRow(datas, row: any) {
    let id = this.currentRow ? "Id" : "$rowId";
    for (const item of datas) {
      if (item[id] == this.currentRow[id]) {
        item.children.unshift(row);
        item.childrenCount = item.children.length;
        item._showChildren = true;
        this.changeRowData(item.Id, "children", item.children)
        this.isShowDataGrid = false
        this.$nextTick(() => {
          this.isShowDataGrid = true
        })
        return true;
      }

      if (item.children) {
        if (this.unshiftTreeRow(item.children, row)) return true;
      }
    }

    return false;

  }



  private addTreeRow(row: any, isAddChild: boolean = false) {

    if (!this.currentRow || !isAddChild) {
      this.datas.unshift(row);
      return;
    }

    this.unshiftTreeRow(this.datas, row);
  }

  private addGridRow(row: any) {
    this.datas.unshift(row);
  }

  /**
   * 添加行
   * @param row row数据
   */
  addRow(row: any, isAddChild: boolean = false) {
    this.addEditData(row);
    if (this.isTree) {
      this.addTreeRow(row, isAddChild);
    } else {
      this.addGridRow(row);
    }
  }

  resize() {
    this.$nextTick(() => {
      this.setting.height = $("#" + this.gridEleId).height()! - 2;
    });
  }

  /**
   * 根据Id获取行数据
   * @param id 
   */
  getRowById(id) {
    return this.getDataRowById(this.datas, id);
  }

  /**
   * 获取选中的数据
   * @param key 
   */
  getCheckedDatas(key?: string) {
    key = this.isNull(key) ? this.defaultChkAllKey : key;
    return this.allDatas.filter(item => item[key!] == true || item[key!] > 0);
  }

  /**
   * 设置Check选择
   * @param id 
   * @param checked 
   * @param key 
   */
  setChecked(id, checked: boolean, key?: string) {
    const row = this.getRowById(id);
    key = this.isNull(key) ? this.defaultChkAllKey : key;
    this.$set(row, key!, checked);
  }

  /**
   * 关闭编辑模式
   */
  closeEditMode() {
    for (const data of this.datas) {
      this.$set(data, '$isEdit', false);
      this.$set(data, "$isChange", false);
    }
  }

  /**
   * 选择行
   * @param dataId 
   */
  selectRow(rowId) {
    // const rowIndex = this.getRowIndexByRowId(rowId);
    const row = this.getRowById(rowId);
    this.currentRow = row;

    this.ref("gridTable").highlightCurrentRow(0, rowId);
  }

  /**
   * 获取所有父级节点
   * @param row 
   * @returns 
   */
  getParentRows(row): any[] {
    return this.getAllParentRows(row, this.allDatas).reverse();
  }

  getSelectRow() {
    return this.currentRow;
  }

  /**
   * 打开编辑模式
   */
  openEditMode() {
    for (const data of this.datas) {
      this.$set(data, '$isEdit', true);
    }
  }

  /** 设置全局点击事件 */
  setGloablClick(click: Function) {
    this.gloablClick = click;
  }

  delete(data) {
    let idKey = data.Id ? "Id" : "$rowId";
    let id = data[idKey];
    let element = this.getRowById(id);

    this.datas.splice(this.datas.indexOf(element), 1);
    this.editDatas.splice(this.editDatas.indexOf(element), 1);
  }

  //#endregion Api

  //#region 属性绑定

  onExpandTree(row_key, status) {
    this.changeRowData(row_key, "_showChildren", status);
  }

  changeRowData(Id, key, value, data: any = 0) {
    let griddata = data == 0 ? this.datas : data;
    let found = false;
    for (let item of griddata) {
      var id = item.Id ? "Id" : "$rowId";
      if (item[id] == Id) {
        this.$set(item, key, value);
        found = true;
        break;
      }
      if (item.children && item.children.length > 0) {
        found = this.changeRowData(Id, key, value, item.children);
        if (found) break;
      }
    }
    return found;
  }

  getIsPagination() {
    return this.setting.isPagination;
  }

  getRowClassName(row) {

    if (this.setting.isTree || this.isNull(row)) return "";

    const classNames: string[] = [];
    // if (row.$rowId && (!row.Id || row.Id == 0)) {
    //   classNames.push('ivu-grid-new-row');
    // }
    if (row.rowIsSelected) {
      classNames.push('ivu-table-row-highlight');
    }
    if (row.$isChange) {
      classNames.push('ivu-table-row-change');
    }

    return classNames.join(" ");

  }

  setGridBoxHeightNow() {
    this.$nextTick(() => {
      const searchHeight = !this.showSearch ? 0 : (this.searchDisplay != 'none' ? $("#" + this.gridBoxId + " .searchDiv").height() : 0);
      const pageHeight = this.getIsPagination() ? 43 : 0;
      const calcHeight = searchHeight! + pageHeight + (this.toolbars.length > 0 ? 38 : 0);
      this.gridBoxHeightNow = `calc(100% - ${calcHeight}px)`;
      this.resize();
    });
  }

  // 监听容器大小改变后重置表格界面
  listenBoxSizeChange() {
    let prevH = $("#" + this.gridEleId).height()
    let fun = () => {
      if (this.gridIsDestroy) {
        return
      }
      setTimeout(() => {
        if ($("#" + this.gridEleId).height() != prevH) {
          this.resize();
        }
        fun()
        prevH = $("#" + this.gridEleId).height()
      }, 1000);
    }

    this.$nextTick(() => {
      fun()
    })
  }
  gridIsDestroy = false   //表格组件是否要被销毁
  beforeDestroy() {
    this.gridIsDestroy = true
  }

  onCurrentChange(currentRow, oldCurrentRow) {
    this.currentRow = currentRow;
    if (this.event.currentChange) {
      this.event.currentChange(currentRow, oldCurrentRow);
    }
  }

  onRowClick(rowData, index) {
    this.currentRow = rowData;
    if (this.event.rowClick) {
      this.event.rowClick(rowData, index);
    }
  }

  onRowDbClick() { }

  onPageChange(pageIndex) {
    this.$emit("pageChange", "pageChange")
    this.pageIndex = pageIndex;
    if (this.readFunction) this.readFunction(this.getLoadDataOptions());
  }

  onSelectAll(selection) {
    if (this.event.selectAll) {
      this.event.selectAll(selection);
    }
  }

  onSelect(selection, row) {
    if (this.event.select) {
      this.event.select(selection, row);
    }
  }


  onSearchToggle() {
    if (this.searchDisplay == "none") {
      this.searchDisplay = "block";
    } else {
      this.searchDisplay = "none";
    }
    this.setGridBoxHeightNow();
  }

  onSearchFun(param) {
    // let keyword = "";
    // let searchParam = "";
    // for (const key in param) {
    //   if (!this.isNull(param[key])) {
    //     searchParam += key + " like '%" + param[key] + "%' and ";
    //     keyword += param[key];
    //   }
    // }
    // searchParam = searchParam.substring(0, searchParam.length - 5);
    // if (searchParam.length == 0) {
    //   searchParam = "1 = 1";
    // }

    if (this.event.event_search) {
      this.setPageIndex(1)//搜索BUG:先点击分页，当前页非1，再搜索：如果搜索的数据只有1页，则不显示  zhangjl 2023年5月31日09:46:41
      this.event.event_search(param);
    }
    // this.$emit("on-search", searchParam, param, keyword.toString());
  }


  // 表头筛选项发生改变
  onFilterChange(param) {
    if (this.event.filterChange) {
      this.event.filterChange(param);
    }
  }

  //#endregion 属性绑定

 async mounted() {

    this.setGridBoxHeightNow();

    setTimeout(() => {
      this.resize();
    }, 100);
    this.listenBoxSizeChange()

  }
}

